/* La Elegant — theme behaviour
   Filtering and sorting are Shopify's, server side. This file only handles
   the header, the load-more button, the WhatsApp message builders and the
   size guide drawer. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function plain(text) {
    var d = document.createElement('div');
    d.innerHTML = String(text == null ? '' : text);
    return (d.textContent || '').replace(/[ \t]+/g, ' ').trim();
  }

  function waLink(message) {
    var n = (window.LA && window.LA.whatsapp ? window.LA.whatsapp : '').replace(/[^0-9]/g, '');
    var clean = String(message).split('\n').map(plain).join('\n');
    return 'https://wa.me/' + n + '?text=' + encodeURIComponent(clean);
  }

  /* ---------- header ---------- */
  function initHeader() {
    var burger = document.querySelector('[data-burger]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (burger && mobileNav) {
      burger.addEventListener('click', function () {
        mobileNav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', mobileNav.classList.contains('is-open') ? 'true' : 'false');
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-mobile-row]'), function (row) {
      var btn = row.querySelector('[data-mobile-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        row.classList.toggle('is-open');
        var marker = btn.querySelector('[data-marker]');
        if (marker) marker.textContent = row.classList.contains('is-open') ? '\u2013' : '+';
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-nav-item]'), function (item) {
      if (!item.querySelector('.nav__drop')) return;
      var open = function () { item.setAttribute('aria-expanded', 'true'); };
      var shut = function () { item.setAttribute('aria-expanded', 'false'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', shut);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', shut);
    });
  }

  /* ---------- filters ----------
     Ticking a box submits the form, so Shopify does the filtering. */
  function initFacets() {
    var form = document.querySelector('[data-facets]');
    if (!form) return;

    Array.prototype.forEach.call(form.querySelectorAll('.facet__input'), function (input) {
      input.addEventListener('change', function () {
        form.setAttribute('data-busy', '');
        form.submit();
      });
    });

    var panels = Array.prototype.slice.call(form.querySelectorAll('[data-facet]'));

    /* one open at a time */
    panels.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        panels.forEach(function (other) { if (other !== d) other.open = false; });
      });
    });

    document.addEventListener('click', function (e) {
      if (form.contains(e.target)) return;
      panels.forEach(function (d) { d.open = false; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      panels.forEach(function (d) { d.open = false; });
    });
  }

  /* ---------- load more ----------
     paginate.next.url carries the active filters and sort, so each load is
     another 20 pieces that match, in the same order. */
  function initLoadMore() {
    var wrap = document.querySelector('[data-load-more]');
    if (!wrap) return;
    var btn = wrap.querySelector('button');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var next = wrap.getAttribute('data-next-url');
      if (!next || wrap.hasAttribute('data-loading')) return;
      wrap.setAttribute('data-loading', '');

      fetch(next)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('[data-grid]');
          Array.prototype.forEach.call(doc.querySelectorAll('[data-grid] > *'), function (node) {
            grid.appendChild(node);
          });

          var nextWrap = doc.querySelector('[data-load-more]');
          var nextUrl = nextWrap ? nextWrap.getAttribute('data-next-url') : '';

          var count = nextWrap ? nextWrap.querySelector('[data-load-count]') : null;
          var mine = wrap.querySelector('[data-load-count]');
          var label = nextWrap ? nextWrap.querySelector('.load-more__idle') : null;
          var myLabel = wrap.querySelector('.load-more__idle');

          if (nextUrl) {
            wrap.setAttribute('data-next-url', nextUrl);
            if (count && mine) mine.textContent = count.textContent;
            if (label && myLabel) myLabel.textContent = label.textContent;
          } else {
            wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () {})
        .then(function () { wrap.removeAttribute('data-loading'); });
    });
  }

  /* ---------- WhatsApp enquiry builder ---------- */
  function initEnquiry() {
    var form = document.querySelector('[data-enquiry]');
    if (!form) return;
    var state = { size: null, look: [], occ: [] };

    function toggleGroup(key, btn) {
      var v = btn.getAttribute('data-value');
      var i = state[key].indexOf(v);
      if (i > -1) state[key].splice(i, 1); else state[key].push(v);
      btn.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      render();
    }
    Array.prototype.forEach.call(form.querySelectorAll('[data-enquiry-size]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state.size = btn.getAttribute('data-value') || null;
        Array.prototype.forEach.call(form.querySelectorAll('[data-enquiry-size]'), function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        render();
      });
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-enquiry-look]'), function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); toggleGroup('look', btn); });
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-enquiry-occ]'), function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); toggleGroup('occ', btn); });
    });
    Array.prototype.forEach.call(form.querySelectorAll('input, textarea'), function (el) {
      el.addEventListener('input', render);
    });

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el && el.value ? el.value.trim() : '';
    }
    function message() {
      var L = ['Hello La Elegant, I would like some help finding something.'];
      L.push('Size: ' + (state.size ? 'UK ' + state.size : 'not sure yet'));
      var m = [];
      if (val('bust')) m.push('bust ' + val('bust'));
      if (val('waist')) m.push('waist ' + val('waist'));
      if (val('hip')) m.push('hip ' + val('hip'));
      if (m.length) L.push('Measurements: ' + m.join(', ') + ' cm');
      if (state.look.length) L.push('Looking for: ' + state.look.join(', '));
      if (state.occ.length) L.push('Occasion: ' + state.occ.join(', '));
      if (val('note')) L.push('Notes: ' + val('note'));
      return L.join('\n');
    }
    function render() {
      var msg = message();
      var preview = document.querySelector('[data-enquiry-preview]');
      if (preview) preview.textContent = msg;
      Array.prototype.forEach.call(document.querySelectorAll('[data-enquiry-send]'), function (a) {
        a.setAttribute('href', waLink(msg));
      });
    }
    render();
  }

  /* ---------- product + cart WhatsApp links ---------- */
  function initProductWhatsApp() {
    var el = document.querySelector('[data-product-wa]');
    if (!el) return;
    var name = el.getAttribute('data-name');
    var price = el.getAttribute('data-price');
    var base = (el.getAttribute('data-url') || window.location.href).split('?')[0];

    function build() {
      var picked = document.querySelector('.size-btn[aria-pressed="true"]');
      var size = picked ? (picked.getAttribute('data-size') || picked.textContent.trim()) : '';
      var variant = picked ? picked.getAttribute('data-variant') : '';
      var link = variant ? base + '?variant=' + variant : base;
      var msg = 'Hello La Elegant, I am asking about ' + name + ' (' + price + ') from your website.';
      if (size) msg += ' I am looking at size ' + size + '.';
      msg += ' Is it still available, and how does it fit?\n' + link;
      Array.prototype.forEach.call(document.querySelectorAll('[data-product-wa]'), function (a) { a.setAttribute('href', waLink(msg)); });
    }
    build();
    Array.prototype.forEach.call(document.querySelectorAll('.size-btn[data-variant]'), function (b) {
      b.addEventListener('click', build);
    });
  }

  function initCartWhatsApp() {
    var el = document.querySelector('[data-cart-wa]');
    if (!el) return;
    var lines = [];
    var i = 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-line]'), function (row) {
      i++;
      var v = row.getAttribute('data-variant');
      var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
      lines.push(i + '. ' + row.getAttribute('data-name') +
                 (v && v !== 'Default Title' ? ' (' + v + ')' : '') +
                 (q > 1 ? ' \u00d7' + q : '') +
                 ' \u2014 ' + row.getAttribute('data-price') +
                 (row.getAttribute('data-url') ? '\n' + row.getAttribute('data-url') : ''));
    });
    if (!lines.length) { el.hidden = true; return; }
    var msg = 'Hello La Elegant, I would like to ask about these pieces together:\n\n' + lines.join('\n\n') +
              '\n\nCould you tell me what is still available and help me choose?';
    el.setAttribute('href', waLink(msg));
  }

  /* ---------- size guide drawer ---------- */
  function initSizeGuide() {
    var modal = document.querySelector('[data-size-guide]');
    if (!modal) return;
    var lastFocus = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = modal.querySelector('[data-size-guide-close]');
      if (close) close.focus();
    }
    function close(e) {
      if (e) e.preventDefault();
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-size-guide-open]'), function (btn) {
      btn.addEventListener('click', open);
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-size-guide-close]'), function (btn) {
      btn.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(e); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close(e);
    });
  }

  ready(function () {
    initHeader();
    initFacets();
    initLoadMore();
    initEnquiry();
    initProductWhatsApp();
    initCartWhatsApp();
    initSizeGuide();
  });
})();
